import type { ChatSummary, MessageDto } from '../api/types';
import type { SupportNotificationPrefs } from '../api/support';
import { isTechnicalDiagnosticMessage } from './technicalDiagnosticMessage';

/** Пока настройки оператора не загружены, поддержка не издаёт уведомлений. */
export function supportNotificationAllowed(message: MessageDto, chat: ChatSummary | undefined, operator: boolean, prefs: SupportNotificationPrefs | null): boolean {
  if (operator && !chat) return false;
  const technical = chat?.isSupport === true && (message.payload.technicalDiagnostic === true || isTechnicalDiagnosticMessage(message, true));
  if (chat?.isSupport && operator) return prefs !== null && (technical ? prefs.notifyErrors : prefs.notifyUsers);
  return !technical;
}
